export default __webpack_public_path__ + "static/media/1.d5dea83e.png";